"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cvrBranches = exports.companyTypes = exports.cvrStatuses = void 0;
exports.cvrStatuses = [
    'Aktiv',
    'NORMAL',
    'Ophørt',
    'OPLØSTEFTERERKLÆRING',
    'OPLØSTEFTERFRIVILLIGLIKVIDATION',
    'OPLØSTEFTERFUSION',
    'OPLØSTEFTERKONKURS',
    'SLETTET',
    'TVANGSOPLØST',
    'UNDERFRIVILLIGLIKVIDATION',
    'UNDERKONKURS',
    'UNDERREKONSTRUKTION',
    'UNDERTVANGSOPLØSNING',
];
exports.companyTypes = [
    'Aktieselskab',
    'Andelsselskab (-forening)',
    'Andelsselskab (-forening) med begrænset ansvar',
    'Anden udenlandsk virksomhed',
    'Anpartsselskab',
    'Enkeltmandsvirksomhed',
    'Erhvervsdrivende fond',
    'Filial af udenlandsk anpartsselskab eller selskab',
    'Folkekirkelige Institutioner',
    'Fonde og andre selvejende institutioner',
    'Forening',
    'Forening med begrænset ansvar',
    'Frivillig forening',
    'Interessentskab',
    'Iværksætterselskab',
    'Kommanditaktieselskab/Partnerselskab',
    'Kommanditselskab',
    'Øvrige virksomhedsformer',
    'Partrederi',
    'Personligt ejet Mindre Virksomhed',
    'Primærkommune',
    'Region',
    'Særlig finansiel virksomhed',
    'Selskab med begrænset ansvar',
    'Statslig administrativ enhed',
];
exports.cvrBranches = {
    '011100': 'Dyrkning af korn (undtagen ris), bælgfrugter og olieholdige frø',
    '011200': 'Dyrkning af ris',
    '011300': 'Dyrkning af grøntsager og meloner, rødder og rodknolde',
    '011400': 'Dyrkning af sukkerrør',
    '011500': 'Dyrkning af tobak',
    '011600': 'Dyrkning af tekstilplanter',
    '011900': 'Dyrkning af andre etårige afgrøder',
    '012100': 'Dyrkning af druer',
    '012200': 'Dyrkning af tropiske og subtropiske frugter',
    '012300': 'Dyrkning af citrusfrugter',
    '012400': 'Dyrkning af kernefrugter og stenfrugter',
    '012500': 'Dyrkning af andre træfrugter, bær og nødder',
    '012600': 'Dyrkning af olieholdige frugter',
    '012700': 'Dyrkning af planter til fremstilling af drikkevarer',
    '012800': 'Dyrkning af krydderiplanter, aromaplanter og lægeplanter',
    '012900': 'Dyrkning af andre flerårige afgrøder',
    '013000': 'Planteformering',
    '014100': 'Avl af malkekvæg',
    '014200': 'Avl af andet kvæg og bøfler',
    '014300': 'Avl af heste og dyr af hestefamilien',
    '014400': 'Avl af kameler og dyr af kamelfamilien',
    '014500': 'Avl af får og geder',
    '014610': 'Avl af smågrise',
    '014620': 'Produktion af slagtesvin',
    '014700': 'Fjerkræavl',
    '014910': 'Kenneler',
    '014920': 'Avl af pelsdyr mv.',
    '015000': 'Blandet drift',
    '016100': 'Serviceydelser i forbindelse med planteavl',
    '016200': 'Serviceydelser i forbindelse med husdyravl',
    '016300': 'Forarbejdning af afgrøder efter høst',
    '016400': 'Forarbejdning af frø/sædekorn til udsæd',
    '017000': 'Jagt, fældefangst og serviceydelser i forbindelse hermed',
    '021000': 'Dyrkning af træer og andre skovbrugsaktiviteter',
    '022000': 'Skovning',
    '023000': 'Indsamling af vildtvoksende forstmateriale undtagen træer',
    '024000': 'Serviceydelser til skovbrug',
    '031100': 'Havfiskeri',
    '031200': 'Ferskvandsfiskeri',
    '032100': 'Havbrug',
    '032200': 'Ferskvandsbrug',
    '051000': 'Indvinding af stenkul',
    '052000': 'Indvinding af brunkul',
    '061000': 'Indvinding af råolie',
    '062000': 'Indvinding af naturgas',
    '071000': 'Brydning af jernmalm',
    '072100': 'Brydning af uran- og thoriummalme',
    '072900': 'Brydning af andre ikke-jernholdige metalmalme',
    '081100': 'Brydning af pynte- og bygningssten, kalksten, gips, kridt og skifer',
    '081200': 'Grus- og sandgravning; indvinding af ler og kaolin',
    '089100': 'Indvinding af mineraler til fremstilling af kemiske produkter og gødningsstoffer',
    '089200': 'Indvinding og agglomerering af tørv',
    '089300': 'Saltindvinding',
    '089900': 'Anden råstofindvinding i.a.n.',
    '091000': 'Serviceydelser i forbindelse med indvinding af råolie og naturgas',
    '099000': 'Serviceydelser i forbindelse med anden råstofindvinding',
    '101110': 'Forarbejdning af svinekød',
    '101190': 'Forarbejdning af andet kød',
    '101200': 'Forarbejdning og konservering af fjerkrækød',
    '101300': 'Produktion af kød- og fjerkrækødprodukter',
    '102010': 'Fremstilling af fiskemel',
    '102020': 'Forarbejdning og konservering af fisk, krebsdyr og bløddyr, undtagen fiskemel',
    '103100': 'Forarbejdning og konservering af kartofler',
    '103200': 'Fremstilling af frugt- og grøntsagssaft',
    '103900': 'Anden forarbejdning og konservering af frugt og grøntsager',
    '104100': 'Fremstilling af olier og fedtstoffer',
    '104200': 'Fremstilling af margarine o.l. spiselige fedtstoffer',
    '105100': 'Mejerier samt ostefremstilling',
    '105200': 'Fremstilling af konsumis',
    '106100': 'Fremstilling af mølleriprodukter',
    '106200': 'Fremstilling af stivelse og stivelsesprodukter',
    '107110': 'Industriel fremstilling af brød; kager mv.',
    '107120': 'Fremstilling af friske bageriprodukter',
    '107200': 'Fremstilling af tvebakker og kiks; fremstilling af konserverede kager, tærter mv.',
    '107300': 'Fremstilling af makaroni, nudler, couscous og lignende dejvarer',
    '108100': 'Fremstilling af sukker',
    '108200': 'Fremstilling af kakao, chokolade og sukkervarer',
    '108300': 'Forarbejdning af te og kaffe',
    '108400': 'Fremstilling af smagspræparater og krydderier',
    '108500': 'Fremstilling af færdigretter',
    '108600': 'Fremstilling af homogeniserede produkter og diætmad',
    '108900': 'Fremstilling af andre fødevarer i.a.n.',
    '109100': 'Fremstilling af færdige foderblandinger til landbrugsdyr',
    '109200': 'Fremstilling af færdige foderblandinger til kæledyr',
    '110100': 'Destillation, rektifikation og blanding af alkohol',
    '110200': 'Fremstilling af vin af druer',
    '110300': 'Fremstilling af cider og anden frugtvin',
    '110400': 'Fremstilling af andre ikke-destillerede gærede drikkevarer',
    '110500': 'Fremstilling af øl',
    '110600': 'Fremstilling af malt',
    '110700': 'Fremstilling af læskedrikke; fremstilling af mineralvand og andet vand på flaske',
    '120000': 'Fremstilling af tobaksprodukter',
    '131000': 'Forbehandling og spinding af tekstilfibre',
    '132000': 'Vævning af tekstiler',
    '133000': 'Efterbehandling af tekstiler',
    '139100': 'Fremstilling af trikotagestoffer',
    '139210': 'Fremstilling af boligtekstiler',
    '139220': 'Fremstilling af færdige tekstilvarer undtagen boligtekstiler og beklædningsartikler',
    '139300': 'Fremstilling af tæpper',
    '139400': 'Fremstilling af reb, tovværk, sejlgarn og netstoffer',
    '139500': 'Fremstilling af fiberdug og varer af fiberdug undtagen beklædningsartikler',
    '139600': 'Fremstilling af andre tekniske og industrielle tekstiler',
    '139900': 'Fremstilling af andre tekstiler i.a.n.',
    '141100': 'Fremstilling af beklædningsartikler af læder',
    '141200': 'Fremstilling af arbejdsbeklædning',
    '141300': 'Fremstilling af anden yderbeklædning',
    '141400': 'Fremstilling af underbeklædning',
    '141900': 'Fremstilling af andre beklædningsartikler samt tilbehør',
    '142000': 'Fremstilling af varer af pelsskind',
    '143100': 'Fremstilling af strikkede og hæklede strømpevarer',
    '143900': 'Fremstilling af andre strikkede og hæklede beklædningsartikler',
    '151100': 'Garvning og beredning af læder; beredning og farvning af pelsskind',
    '151200': 'Fremstilling af tasker, kufferter, sadelmagervarer mv.',
    '152000': 'Fremstilling af fodtøj',
    '161000': 'Udsavning og høvling af træ',
    '162100': 'Fremstilling af finerplader og træbaserede plader',
    '162200': 'Fremstilling af sammensatte parketstave',
    '162300': 'Fremstilling af bygningstømmer og snedkeriartikler i øvrigt',
    '162400': 'Fremstilling af træemballage',
    '162900': 'Fremstilling af andre træprodukter; fremstilling af varer af kork, strå og flettematerialer',
    '171100': 'Fremstilling af papirmasse',
    '171200': 'Fremstilling af papir og pap',
    '172100': 'Fremstilling af bølgepap og pap og emballage af papir og pap',
    '172200': 'Fremstilling af husholdningsartikler og hygiejneartikler samt toiletartikler af papir og pap',
    '172300': 'Fremstilling af kontorartikler af papir',
    '172400': 'Fremstilling af tapet',
    '172900': 'Fremstilling af andre papir- og papvarer',
    '181100': 'Trykning af dagblade',
    '181200': 'Anden trykning',
    '181300': 'Prepress- og premedia-arbejde',
    '181400': 'Bogbinding og lignende serviceydelser',
    '182000': 'Reproduktion af indspillede medier',
    '191000': 'Fremstilling af koks mv.',
    '192000': 'Fremstilling af raffinerede mineralolieprodukter',
    '201100': 'Fremstilling af industrigasser',
    '201200': 'Fremstilling af farvestoffer og pigmenter',
    '201300': 'Fremstilling af andre uorganiske basiskemikalier',
    '201400': 'Fremstilling af andre organiske basiskemikalier',
    '201500': 'Fremstilling af gødningsstoffer og nitrogenprodukter',
    '201600': 'Fremstilling af plast i ubearbejdet form',
    '201700': 'Fremstilling af syntetisk gummi i ubearbejdet form',
    '202000': 'Fremstilling af pesticider og andre agrokemiske produkter',
    '203000': 'Fremstilling af maling, lak og lignende overfladebehandlingsmidler, trykfarver samt tætningsmaterialer',
    '204100': 'Fremstilling af sæbe, rengørings- og rensemidler samt poleremidler',
    '204200': 'Fremstilling af parfume, hårshampoo, tandpasta mv.',
    '205100': 'Fremstilling af sprængstoffer',
    '205200': 'Fremstilling af lim',
    '205300': 'Fremstilling af æteriske olier',
    '205900': 'Fremstilling af andre kemiske produkter i.a.n.',
    '206000': 'Fremstilling af kemofibre',
    '211000': 'Fremstilling af farmaceutiske råvarer',
    '212000': 'Fremstilling af farmaceutiske præparater',
    '221100': 'Fremstilling af gummidæk og gummislanger; vulkanisering af dæk',
    '221900': 'Fremstilling af andre gummiprodukter',
    '222100': 'Fremstilling af plader, ark, rør og slanger samt profiler af plast',
    '222200': 'Fremstilling af plastemballage',
    '222300': 'Fremstilling af bygningsartikler af plast',
    '222900': 'Fremstilling af andre plastprodukter',
    '231100': 'Fremstilling af planglas',
    '231200': 'Formning og forarbejdning af planglas',
    '231300': 'Fremstilling af flasker, drikkeglas mv.',
    '231400': 'Fremstilling af glasfiber',
    '231900': 'Fremstilling og bearbejdning af andet glas (herunder teknisk glas)',
    '232000': 'Fremstilling af ildfaste produkter',
    '233100': 'Fremstilling af keramiske teglsten og gulvfliser',
    '233200': 'Fremstilling af mursten, teglsten og byggematerialer af brændt ler',
    '234100': 'Fremstilling af keramiske husholdningsartikler og pyntegenstande',
    '234200': 'Fremstilling af keramiske sanitetsartikler',
    '234300': 'Fremstilling af keramiske isolatorer og isoleringsdele',
    '234400': 'Fremstilling af andre keramiske produkter til teknisk brug',
    '234900': 'Fremstilling af andre keramiske produkter',
    '235100': 'Fremstilling af cement',
    '235200': 'Fremstilling af kalk og gips',
    '236100': 'Fremstilling af byggematerialer af beton',
    '236200': 'Fremstilling af byggematerialer af gips',
    '236300': 'Fremstilling af færdigblandet beton',
    '236400': 'Fremstilling af mørtel',
    '236500': 'Fremstilling af fibercement',
    '236900': 'Fremstilling af andre beton-, gips- og cementprodukter',
    '237000': 'Tilhugning, tilskæring og færdigbearbejdning af sten',
    '239100': 'Fremstilling af slibemidler',
    '239910': 'Fremstilling af asfalt og tagpap',
    '239990': 'Fremstilling af andre ikke-metalholdige mineralske produkter i.a.n.',
    '241000': 'Fremstilling af råjern og råstål samt jernlegeringer',
    '242000': 'Fremstilling af rør og hule profiler og tilhørende fittings af stål',
    '243100': 'Fremstilling af stænger ved koldtrækning',
    '243200': 'Fremstilling af stålbånd ved koldvalsning',
    '243300': 'Koldbehandling',
    '243400': 'Fremstilling af tråd ved koldtrækning',
    '244100': 'Fremstilling af ædelmetaller',
    '244200': 'Fremstilling af aluminium',
    '244300': 'Fremstilling af bly, zink og tin',
    '244400': 'Fremstilling af kobber',
    '244500': 'Anden fremstilling af ikke-jernholdige metaller',
    '244600': 'Oparbejdning af nukleart brændsel',
    '245100': 'Støbning af jernprodukter',
    '245200': 'Støbning af stålprodukter',
    '245300': 'Støbning af letmetalprodukter',
    '245400': 'Støbning af andre ikke-jernholdige metalprodukter',
    '251100': 'Fremstilling af metalkonstruktioner og dele heraf',
    '251200': 'Fremstilling af døre og vinduer af metal',
    '252100': 'Fremstilling af radiatorer og kedler til centralvarmeanlæg',
    '252900': 'Fremstilling af andre tanke og beholdere af metal',
    '253000': 'Fremstilling af dampkedler undtagen centralvarmekedler',
    '254000': 'Fremstilling af våben og ammunition',
    '255000': 'Smedning, presning, sænksmedning og valsning af metal; pulvermetallurgi',
    '256100': 'Overfladebehandling af metal',
    '256200': 'Maskinforarbejdning',
    '257100': 'Fremstilling af bestik, skære- og klipperedskaber',
    '257200': 'Fremstilling af låse og hængsler',
    '257300': 'Fremstilling af håndværktøj',
    '259100': 'Fremstilling af metaltønder og lignende beholdere',
    '259200': 'Fremstilling af letmetalemballage',
    '259300': 'Fremstilling af trådvarer, kæder og fjedre',
    '259400': 'Fremstilling af lukkeanordninger, bolte, skruer og møtrikker',
    '259900': 'Fremstilling af andre færdige metalprodukter i.a.n.',
    '261100': 'Fremstilling af elektroniske komponenter og plader',
    '261200': 'Fremstilling af printplader o.l.',
    '262000': 'Fremstilling af computere og ydre enheder',
    '263000': 'Fremstilling af kommunikationsudstyr',
    '264000': 'Fremstilling af elektronik til husholdninger',
    '265100': 'Fremstilling af udstyr til måling, afprøvning, navigation og kontrol',
    '265200': 'Fremstilling af ure',
    '266010': 'Fremstilling af høreapparater og dele hertil',
    '266090': 'Fremstilling af bestrålingsudstyr og elektromedicinsk og elektroterapeutisk udstyr',
    '267000': 'Fremstilling af optiske instrumenter og fotografisk udstyr',
    '268000': 'Fremstilling af magnetiske og optiske media',
    '271100': 'Fremstilling af elektriske motorer, generatorer og transformere',
    '271200': 'Fremstilling af elektriske fordelings- og kontrolapparater',
    '272000': 'Fremstilling af batterier og akkumulatorer',
    '273100': 'Fremstilling af lyslederkabler',
    '273200': 'Fremstilling af andre elektroniske og elektriske ledninger og kabler',
    '273300': 'Fremstilling af tilbehør til ledninger og kabler',
    '274000': 'Fremstilling af elektriske belysningsartikler',
    '275100': 'Fremstilling af elektriske husholdningsapparater',
    '275200': 'Fremstilling af ikke-elektriske husholdningsapparater',
    '279000': 'Fremstilling af andet elektrisk udstyr',
    '281110': 'Fremstilling af vindmøller og dele hertil',
    '281190': 'Fremstilling af motorer og turbiner undtagen motorer til vindmøller, flyvemaskiner, motorkøretøjer og knallerter',
    '281200': 'Fremstilling af hydraulisk udstyr',
    '281300': 'Fremstilling af andre pumper og kompressorer',
    '281400': 'Fremstilling af andre haner og ventiler',
    '281500': 'Fremstilling af lejer, tandhjul, tandhjulsudvekslinger og drivelementer',
    '282100': 'Fremstilling af ovne, ildsteder og fyringsaggregater',
    '282200': 'Fremstilling af løfte- og håndteringsudstyr',
    '282300': 'Fremstilling af kontormaskiner og -udstyr (undtagen computere og ydre enheder)',
    '282400': 'Fremstilling af motordrevet håndværktøj',
    '282500': 'Fremstilling af køle- og ventilationsanlæg (til industriel brug)',
    '282900': 'Fremstilling af andre maskiner til generelle formål i.a.n.',
    '283000': 'Fremstilling af landbrugs- og skovbrugsmaskiner',
    '284100': 'Fremstilling af metalforarbejdende værktøjsmaskiner',
    '284900': 'Fremstilling af andre værktøjsmaskiner',
    '289100': 'Fremstilling af maskiner til metallurgi',
    '289200': 'Fremstilling af maskiner til råstofindvindingsindustrien samt bygge og anlæg',
    '289300': 'Fremstilling af maskiner til føde-, drikke- og tobaksvareindustrien',
    '289400': 'Fremstilling af maskiner til produktion af tekstiler, beklædningsartikler og læder',
    '289500': 'Fremstilling af maskiner til produktion af papir og pap',
    '289600': 'Fremstilling af maskiner til produktion af plast og gummi',
    '289900': 'Fremstilling af øvrige maskiner til specielle formål i.a.n.',
    '291000': 'Fremstilling af motorkøretøjer',
    '292000': 'Fremstilling af karosserier til motorkøretøjer; fremstilling af påhængsvogne og sættevogne',
    '293100': 'Fremstilling af elektrisk og elektronisk udstyr til motorkøretøjer',
    '293200': 'Fremstilling af andre dele og tilbehør til motorkøretøjer',
    '301100': 'Bygning af skibe og flydende materiel',
    '301200': 'Bygning af både til fritid og sport',
    '302000': 'Fremstilling af lokomotiver og andet rullende materiel til jernbaner og sporveje',
    '303000': 'Fremstilling af luft- og rumfartøjer o.l.',
    '304000': 'Fremstilling af militære kampkøretøjer',
    '309100': 'Fremstilling af motorcykler',
    '309200': 'Fremstilling af cykler og invalidekøretøjer',
    '309900': 'Fremstilling af andre transportmidler i.a.n.',
    '310100': 'Fremstilling af kontor- og butiksmøbler',
    '310200': 'Fremstilling af køkkenmøbler',
    '310300': 'Fremstilling af madrasser',
    '310900': 'Fremstilling af andre møbler',
    '321100': 'Prægning af mønter',
    '321200': 'Fremstilling af smykker i ædle metaller og relaterede produkter',
    '321300': 'Fremstilling af bijouteri og lignende varer',
    '322000': 'Fremstilling af musikinstrumenter',
    '323000': 'Fremstilling af sportsudstyr',
    '324000': 'Fremstilling af spil og legetøj',
    '325000': 'Fremstilling af medicinske og dentale instrumenter samt udstyr hertil',
    '329100': 'Fremstilling af koste og børster',
    '329900': 'Anden fremstillingsvirksomhed i.a.n.',
    '331100': 'Reparation af jern- og metalvarer',
    '331200': 'Reparation af maskiner',
    '331300': 'Reparation af elektronisk og optisk udstyr',
    '331400': 'Reparation af elektrisk udstyr',
    '331500': 'Reparation og vedligeholdelse af skibe og både',
    '331600': 'Reparation og vedligeholdelse af luft- og rumfartøjer',
    '331700': 'Reparation og vedligeholdelse af andre transportmidler',
    '331900': 'Reparation af andet udstyr',
    '332000': 'Installation af industrimaskiner og -udstyr',
    '351100': 'Produktion af elektricitet',
    '351200': 'Transmission af elektricitet',
    '351300': 'Distribution af elektricitet',
    '351400': 'Handel med elektricitet',
    '352100': 'Fremstilling af gas',
    '352200': 'Distribution af gas',
    '352300': 'Handel med gas gennem rørledninger',
    '353000': 'Varmeforsyning',
    '360000': 'Vandforsyning',
    '370000': 'Opsamling og behandling af spildevand',
    '381100': 'Indsamling af ikke-farligt affald',
    '381200': 'Indsamling af farligt affald',
    '382110': 'Behandling og bortskaffelse af ikke-farligt affald',
    '382120': 'Bortskaffelse af affald med energiproduktion',
    '382200': 'Behandling og bortskaffelse af farligt affald',
    '383100': 'Demontering af udtjente køretøjer, skibe, maskiner mv.',
    '383200': 'Genbrug af sorterede materialer',
    '390000': 'Rensning af jord og grundvand og anden form for forureningsbekæmpelse',
    '411000': 'Gennemførelse af byggeprojekter',
    '412000': 'Opførelse af bygninger',
    '421000': 'Anlæg af veje og jernbaner',
    '421100': 'Anlæg af veje og motorveje',
    '421200': 'Anlæg af jernbaner og undergrundsbaner',
    '421300': 'Anlæg af broer og tunneller',
    '422000': 'Anlæg af ledningsnet',
    '422100': 'Anlæg af ledningsnet til væsker',
    '422200': 'Anlæg af ledningsnet til elektricitet og kommunikation',
    '429000': 'Anden anlægsvirksomhed',
    '429100': 'Anlæg af vandveje, havne, diger og dæmninger',
    '429900': 'Anden anlægsvirksomhed i.a.n.',
    '431100': 'Nedrivning',
    '431200': 'Forberedende byggepladsarbejder',
    '431300': 'Funderingsundersøgelser',
    '432100': 'El-installation',
    '432200': 'VVS- og blikkenslagerforretninger',
    '432900': 'Anden bygningsinstallationsvirksomhed',
    '433100': 'Stukkatørvirksomhed',
    '433200': 'Tømrer- og bygningssnedkervirksomhed',
    '433300': 'Udførelse af gulvbelægninger og vægbeklædning',
    '433410': 'Malerforretninger',
    '433420': 'Glarmestervirksomhed',
    '433900': 'Anden bygningsfærdiggørelse',
    '439100': 'Tagdækningsvirksomhed',
    '439910': 'Murere',
    '439990': 'Anden bygge- og anlægsvirksomhed, som kræver specialisering',
    '451110': 'Engroshandel med personbiler, varebiler og minibusser',
    '451120': 'Detailhandel med personbiler, varebiler og minibusser',
    '451910': 'Engros- og detailhandel med campingkøretøjer, små trailere mv.',
    '451920': 'Engros- og detailhandel med lastbiler og påhængsvogne mv.',
    '452010': 'Autoreparationsværksteder mv.',
    '452020': 'Karosseriværksteder og autolakererier',
    '452030': 'Undervognsbehandling',
    '452040': 'Dækservice',
    '453100': 'Engroshandel med reservedele og tilbehør til motorkøretøjer',
    '453200': 'Detailhandel med reservedele og tilbehør til motorkøretøjer',
    '454000': 'Salg, vedligeholdelse og reparation af motorcykler og reservedele og tilbehør hertil',
    '461100': 'Agenturhandel med landbrugsråvarer, levende dyr, tekstilmaterialer og halvfabrikata',
    '461200': 'Agenturhandel med brændstoffer, malme, metaller og kemiske produkter til industrien',
    '461300': 'Agenturhandel med tømmer og andre byggematerialer',
    '461400': 'Agenturhandel med maskiner, teknisk udstyr, skibe og flyvemaskiner',
    '461500': 'Agenturhandel med møbler, husholdningsartikler og isenkram',
    '461600': 'Agenturhandel med tekstiler, beklædning, pelsværk, fodtøj og lædervarer',
    '461710': 'Fiskeauktioner',
    '461790': 'Anden agenturhandel med føde-, drikke- og tobaksvarer',
    '461800': 'Agenturhandel med specialiseret varesortiment i.a.n.',
    '461900': 'Agenturhandel med blandet sortiment',
    '462100': 'Engroshandel med korn, uforarbejdet tobak, såsæd og foderstoffer',
    '462200': 'Engroshandel med blomster og planter',
    '462300': 'Engroshandel med levende dyr',
    '462400': 'Engroshandel med huder, skind og læder',
    '463100': 'Engroshandel med frugt og grøntsager',
    '463200': 'Engroshandel med kød og kødprodukter',
    '463300': 'Engroshandel med mejeriprodukter, æg samt spiselige olier og fedtstoffer',
    '463410': 'Engroshandel med øl, mineralvand, frugt- og grøntsagssaft',
    '463420': 'Engroshandel med vin og spiritus',
    '463500': 'Engroshandel med tobaksvarer',
    '463600': 'Engroshandel med sukker, chokolade og sukkervarer',
    '463700': 'Engroshandel med kaffe, te, kakao og krydderier',
    '463810': 'Engroshandel med fisk og fiskeprodukter',
    '463890': 'Specialiseret engroshandel med fødevarer i.a.n.',
    '463900': 'Ikke-specialiseret engroshandel med føde-, drikke- og tobaksvarer',
    '464100': 'Engroshandel med tekstiler',
    '464210': 'Engroshandel med beklædning',
    '464220': 'Engroshandel med fodtøj',
    '464310': 'Engroshandel med hårde hvidevarer',
    '464320': 'Engroshandel med radio og tv mv.',
    '464330': "Engroshandel med indspillede videoer, cd'er, dvd'er mv.",
    '464340': 'Engroshandel med fotografiske og optiske artikler',
    '464350': 'Engroshandel med elektriske husholdningsartikler',
    '464410': 'Engroshandel med porcelæns- og glasvarer',
    '464420': 'Engroshandel med rengøringsmidler',
    '464500': 'Engroshandel med parfumerivarer og kosmetik',
    '464610': 'Engroshandel med medicinalvarer og sygeplejeartikler',
    '464620': 'Engroshandel med læge- og hospitalsartikler',
    '464700': 'Engroshandel med møbler, tæpper og belysningsartikler',
    '464800': 'Engroshandel med ure, smykker og guld- og sølvvarer',
    '464910': 'Engroshandel med cykler, sportsartikler og lystbåde',
    '464920': 'Engroshandel med bøger, papir og papirvarer',
    '464930': 'Engroshandel med kufferter og lædervarer',
    '464990': 'Engroshandel med andre husholdningsartikler',
    '465100': 'Engroshandel med computere, ydre enheder og software',
    '465210': 'Engroshandel med elektronisk udstyr',
    '465220': 'Engroshandel med telekommunikationsudstyr',
    '466100': 'Engroshandel med landbrugsmaskiner, -udstyr og tilbehør hertil',
    '466200': 'Engroshandel med værktøjsmaskiner',
    '466300': 'Engroshandel med maskiner til minedrift og bygge- og anlægsvirksomhed',
    '466400': 'Engroshandel med maskiner, udstyr og tilbehør til tekstilindustrien',
    '466500': 'Engroshandel med kontormøbler',
    '466600': 'Engroshandel med andre kontormaskiner og andet kontorudstyr',
    '466900': 'Engroshandel med andre maskiner og andet udstyr',
    '467100': 'Engroshandel med fast, flydende og luftformigt brændstof og lignende varer',
    '467200': 'Engroshandel med metaller og metalmalme',
    '467310': 'Engroshandel med træ, trælast og byggematerialer',
    '467320': 'Engroshandel med lak, maling, tapet, gulvbelægning mv.',
    '467400': 'Engroshandel med isenkram, varmeanlæg og tilbehør',
    '467500': 'Engroshandel med kemiske produkter',
    '467600': 'Engroshandel med andre råvarer og halvfabrikata',
    '467700': 'Engroshandel med affaldsprodukter',
    '469000': 'Ikke-specialiseret engroshandel',
    '471110': 'Købmænd og døgnkiosker',
    '471120': 'Supermarkeder',
    '471130': 'Discountforretninger',
    '471900': 'Anden detailhandel fra ikke-specialiserede forretninger',
    '472100': 'Frugt- og grøntforretninger',
    '472200': 'Slagter- og viktualieforretninger',
    '472300': 'Fiskeforretninger',
    '472400': 'Detailhandel med brød, konditori- og sukkervarer',
    '472500': 'Detailhandel med drikkevarer',
    '472600': 'Tobaksforretninger',
    '472900': 'Anden detailhandel med fødevarer i specialforretninger',
    '473000': 'Servicestationer',
    '474100': 'Detailhandel med computere, ydre enheder og software',
    '474200': 'Detailhandel med telekommunikationsudstyr',
    '474300': 'Radio- og tv-forretninger',
    '475100': 'Detailhandel med kjolestoffer, garn, broderier mv.',
    '475210': 'Farve- og tapetforretninger',
    '475220': 'Byggemarkeder og værktøjsmagasiner',
    '475300': 'Detailhandel med tæpper, vægbeklædning og gulvbelægning',
    '475400': 'Detailhandel med elektriske husholdningsapparater',
    '475910': 'Møbelforretninger',
    '475920': 'Boligtekstilforretninger',
    '475930': 'Detailhandel med køkkenudstyr, glas, porcelæn, bestik, vaser, lysestager mv.',
    '475940': 'Forhandlere af musikinstrumenter',
    '475990': 'Detailhandel med belysningsartikler samt husholdningsartikler i.a.n.',
    '476100': 'Detailhandel med bøger',
    '476200': 'Detailhandel med aviser og papirvarer',
    '476300': 'Detailhandel med musik- og videooptagelser',
    '476410': 'Forhandlere af sports- og campingudstyr',
    '476420': 'Cykel- og knallertforretninger',
    '476430': 'Forhandlere af lystbåde og udstyr hertil',
    '476500': 'Detailhandel med spil og legetøj',
    '477110': 'Tøjforretninger',
    '477120': 'Babyudstyrs- og børnetøjsforretninger',
    '477210': 'Skotøjsforretninger',
    '477220': 'Lædervareforretninger',
    '477300': 'Apoteker',
    '477400': 'Detailhandel med medicinske og ortopædiske artikler',
    '477500': 'Detailhandel med kosmetikvarer og produkter til personlig pleje',
    '477610': 'Blomsterforretninger',
    '477620': 'Planteforhandlere og havecentre',
    '477630': 'Dyrehandel',
    '477700': 'Detailhandel med ure, smykker og guld- og sølvvarer',
    '477810': 'Optikere',
    '477820': 'Fotoforretninger',
    '477830': 'Forhandlere af gaveartikler og brugskunst',
    '477840': 'Kunsthandel og gallerivirksomhed',
    '477890': 'Detailhandel med andre varer i.a.n.',
    '477900': 'Detailhandel med brugte varer i forretninger',
    '478100': 'Detailhandel med føde-, drikke- og tobaksvarer fra stadepladser og markeder',
    '478200': 'Detailhandel med tekstiler, beklædningsartikler og fodtøj fra stadepladser og markeder',
    '478900': 'Detailhandel med andre varer fra stadepladser og markeder',
    '479110': 'Detailhandel fra postordreforretninger',
    '479111': 'Detailhandel med dagligvarer via internet',
    '479112': 'Detailhandel med elektroniske eller elektriske apparater samt fotoudstyr via internet',
    '479113': 'Detailhandel med husholdnings- eller boligudstyr, bortset fra elektriske apparater, via internet',
    '479114': 'Detailhandel med bøger, kontorartikler, musik eller film via internet',
    '479115': 'Detailhandel med hobbyartikler, musikinstrumenter, sportsudstyr, legetøj, cykler via internet',
    '479116': 'Detailhandel med tøj, sko, lædervarer, ure eller babyudstyr  via internet',
    '479117': 'Detailhandel med medicin og produkter til personlig pleje via internet',
    '479119': 'Detailhandel med andre varer i.a.n. via internet',
    '479120': 'Detailhandel via Internettet med digitale produkter',
    '479900': 'Anden detailhandel undtagen fra forretninger, stadepladser og markeder',
    '491000': 'Passagertransport med regional- eller fjerntog',
    '492000': 'Godstransport med tog',
    '493110': 'Rutebuskørsel, by- og nærtrafik',
    '493120': 'S-togstrafik, metro og andre nærbaner',
    '493200': 'Taxikørsel',
    '493910': 'Rutebuskørsel, fjerntrafik og skolebusser',
    '493920': 'Turistkørsel og anden landpassagertransport',
    '494100': 'Vejgodstransport',
    '494200': 'Flytteforretninger',
    '495000': 'Rørtransport',
    '501000': 'Sø- og kysttransport af passagerer',
    '502000': 'Sø- og kysttransport af gods',
    '503000': 'Transport af passagerer ad indre vandveje',
    '504000': 'Transport af gods ad indre vandveje',
    '511010': 'Ruteflyvning',
    '511020': 'Charter- og taxiflyvning',
    '512100': 'Lufttransport af gods',
    '512200': 'Rumfart',
    '521000': 'Oplagrings- og pakhusvirksomhed',
    '522110': 'Stationer, godsterminaler mv.',
    '522120': 'Parkering og vejhjælp mv.',
    '522130': 'Drift af betalingsveje, -broer og -tunneler',
    '522210': 'Erhvervshavne',
    '522220': 'Bugserings-, bjærgnings- og redningsvæsen mv.',
    '522300': 'Serviceydelser i forbindelse med luftfart',
    '522400': 'Godshåndtering',
    '522910': 'Skibsmæglere',
    '522920': 'Speditører',
    '522990': 'Andre tjenesteydelser i forbindelse med transport',
    '531000': 'Posttjenester omfattet af forsyningspligten',
    '532000': 'Andre post- og kurertjenester',
    '551010': 'Hoteller',
    '551020': 'Konferencecentre og kursusejendomme',
    '552000': 'Ferieboliger og andre indlogeringsfaciliteter til kortvarige ophold',
    '553000': 'Campingpladser',
    '559000': 'Andre overnatningsfaciliteter',
    '561010': 'Restauranter',
    '561020': 'Pizzeriaer, grillbarer, isbarer mv.',
    '562100': 'Event catering',
    '562900': 'Anden restaurationsvirksomhed',
    '563000': 'Cafeér, værtshuse, diskoteker mv.',
    '581100': 'Udgivelse af bøger',
    '581200': 'Udgivelse af telefonbøger og adresselister',
    '581300': 'Udgivelse af aviser og dagblade',
    '581410': 'Udgivelse af ugeblade og magasiner',
    '581420': 'Udgivelse af distrikts- og annonceblade',
    '581900': 'Anden udgivervirksomhed',
    '582100': 'Udgivelse af computerspil',
    '582900': 'Anden udgivelse af software',
    '591110': 'Produktion af film og videofilm',
    '591120': 'Produktion af tv-programmer',
    '591200': 'Aktiviteter, der udøves efter produktion af film, video- og tv-programmer',
    '591300': 'Distribution af film, video- og tv-programmer',
    '591400': 'Biografer',
    '592000': 'Indspilning af lydoptagelser og udgivelse af musik',
    '601000': 'Radiovirksomhed',
    '602000': 'Tv-virksomhed',
    '611000': 'Fastnetbaseret telekommunikation',
    '612000': 'Trådløs telekommunikation',
    '613000': 'Satellitbaseret telekommunikation',
    '619000': 'Anden telekommunikation',
    '620100': 'Computerprogrammering',
    '620200': 'Konsulentbistand vedrørende informationsteknologi',
    '620300': 'Computer facility management',
    '620900': 'Anden it-servicevirksomhed',
    '631100': 'Databehandling, webhosting og lignende serviceydelser',
    '631200': 'Webportaler',
    '639100': 'Pressebureauer',
    '639900': 'Andre informationstjenester i.a.n.',
    '641100': 'Centralbanker',
    '641900': 'Banker, sparekasser og andelskasser',
    '642010': 'Finansielle holdingselskaber',
    '642020': 'Ikke-finansielle holdingselskaber',
    '642030': 'Gennemløbsholdingselskaber',
    '643010': 'Investeringsforeninger',
    '643020': 'Pengemarkedsforeninger',
    '643030': 'Investeringsselskaber',
    '643040': 'Ventureselskaber og kapitalfonde',
    '649100': 'Finansiel leasing',
    '649210': 'Realkreditinstitutter',
    '649220': 'Andre kreditinstitutter',
    '649230': 'Andre kreditselskaber',
    '649240': 'FVC-selskaber',
    '649900': 'Anden finansiel formidling undtagen forsikring og pensionsforsikring, i.a.n.',
    '651100': 'Livsforsikring',
    '651200': 'Anden forsikring',
    '652000': 'Genforsikring',
    '653010': 'Pensionskasser',
    '653020': 'Anden pensionsforsikring',
    '661100': 'Forvaltning af kapitalmarkeder',
    '661200': 'Værdipapir- og varemægling',
    '661900': 'Andre hjælpetjenester i forbindelse med finansiel formidling',
    '662100': 'Risiko- og skadesvurdering',
    '662200': 'Forsikringsagenters og forsikringsmægleres virksomhed',
    '662900': 'Andre hjælpetjenester i forbindelse med forsikring og pensionsforsikring',
    '663000': 'Formueforvaltning',
    '681000': 'Køb og salg af egen fast ejendom',
    '682010': 'Almennyttige boligselskaber',
    '682020': 'Private andelsboligforeninger',
    '682030': 'Anden udlejning af boliger',
    '682040': 'Udlejning af erhvervsejendomme',
    '683110': 'Ejendomsmæglere mv.',
    '683120': 'Boliganvisning, ferieboligudlejning mv.',
    '683210': 'Administration af fast ejendom på kontraktbasis',
    '683220': 'Ejerforeninger',
    '691000': 'Juridisk bistand',
    '692000': 'Bogføring og revision; skatterådgivning',
    '701010': 'Ikke-finansielle hovedsæders virksomhed',
    '701020': 'Finansielle hovedsæders virksomhed',
    '702100': 'Public relations og kommunikation',
    '702200': 'Virksomhedsrådgivning og anden rådgivning om driftsledelse',
    '711100': 'Arkitektvirksomhed',
    '711210': 'Rådgivende ingeniørvirksomhed inden for byggeri og anlægsarbejder',
    '711220': 'Rådgivende ingeniørvirksomhed inden for produktions- og maskinteknik',
    '711230': 'Opstilling og levering af færdige fabriksanlæg',
    '711240': 'Geologiske undersøgelser og prospektering, landinspektører mv.',
    '711290': 'Anden teknisk rådgivning',
    '712010': 'Kontrol af levnedsmidler',
    '712020': 'Teknisk afprøvning og kontrol',
    '712090': 'Anden måling og teknisk analyse',
    '721100': 'Forskning og eksperimentel udvikling indenfor bioteknologi',
    '721900': 'Anden forskning og eksperimentel udvikling inden for naturvidenskab og teknik',
    '722000': 'Forskning og eksperimentel udvikling inden for samfundsvidenskab og humanistiske videnskaber',
    '731110': 'Reklamebureauer',
    '731190': 'Anden reklamevirksomhed',
    '731200': 'Reklameplads i medier',
    '732000': 'Markedsanalyse og offentlig meningsmåling',
    '741010': 'Industriel design og produktdesign',
    '741020': 'Kommunikationsdesign og grafisk design',
    '741030': 'Indretningsarkitekter og rumdesign',
    '742000': 'Fotografisk virksomhed',
    '743000': 'Oversættelse og tolkning',
    '749010': 'Landbrugskonsulenter',
    '749090': 'Andre liberale, videnskabelige og tekniske tjenesteydelser i.a.n.',
    '750000': 'Dyrlæger',
    '771100': 'Udlejning og leasing af biler og lette motorkøretøjer',
    '771200': 'Udlejning og leasing af lastbiler',
    '772100': 'Udlejning og leasing af varer til fritid og sport',
    '772200': 'Udlejning af videobånd og videodisks',
    '772900': 'Udlejning og leasing af andre varer til personlig brug og husholdningsbrug i.a.n.',
    '773100': 'Udlejning og leasing af landbrugsmaskiner og -udstyr',
    '773200': 'Udlejning og leasing af entreprenørmateriel',
    '773300': 'Udlejning af kontormaskiner og -udstyr, computere og it-udstyr',
    '773400': 'Udlejning og leasing af skibe og både',
    '773500': 'Udlejning og leasing af luftfartøjer',
    '773900': 'Udlejning og leasing af andet materiel, udstyr og andre materielle aktiver i.a.n.',
    '774000': 'Leasing af intellektuelle ejendomsrettigheder og lignende, dog ikke ophavsretsbeskyttede værker',
    '781000': 'Arbejdsformidlingskontorer',
    '782000': 'Vikarbureauer',
    '783000': 'Anden personaleformidling',
    '791100': 'Rejsebureauer',
    '791200': 'Rejsearrangører',
    '799000': 'Andre reservationstjenesteydelser og tjenesteydelser i forbindelse hermed',
    '801000': 'Private vagt- og sikkerhedstjenester',
    '802000': 'Serviceydelser i forbindelse med sikkerhedssystemer',
    '803000': 'Overvågning',
    '811000': 'Kombinerede serviceydelser',
    '812100': 'Almindelig rengøring i bygninger',
    '812210': 'Vinduespolering',
    '812220': 'Skorstensfejning',
    '812290': 'Anden rengøring af bygninger og rengøring af erhvervslokaler',
    '812900': 'Andre rengøringsydelser',
    '813000': 'Landskabspleje',
    '821100': 'Kombinerede administrationsserviceydelser',
    '821900': 'Fotokopiering, dokumentbehandling og anden specialiseret kontorservice',
    '822000': 'Call centres virksomhed',
    '823000': 'Organisering af kongresser, messer og udstillinger',
    '829100': 'Inkassovirksomhed og kreditoplysning',
    '829200': 'Pakkerier',
    '829900': 'Anden forretningsservice i.a.n.',
    '841100': 'Generelle offentlige tjenester',
    '841200': 'Administration af sundhedsvæsen, undervisning, kultur og sociale forhold undtagen social sikring',
    '841300': 'Administration af og bidrag til erhvervsfremme',
    '842100': 'Udenrigsanliggender',
    '842200': 'Forsvar',
    '842300': 'Domstole og fængselsvæsen',
    '842400': 'Politi',
    '842500': 'Brandvæsen',
    '843000': 'Lovpligtig socialsikring mv.',
    '851000': 'Førskoleundervisning',
    '852010': 'Folkeskoler o.lign.',
    '852020': 'Specialskoler for handicappede',
    '853110': 'Ungdoms- og efterskoler',
    '853120': 'Gymnasier, studenter- og HF-kurser',
    '853200': 'Tekniske skoler og fagskoler',
    '854100': 'Videregående uddannelser ikke på universitetsniveau',
    '854200': 'Videregående uddannelser på universitetsniveau',
    '855100': 'Undervisning inden for sport og fritid',
    '855200': 'Undervisning i kulturelle discipliner',
    '855300': 'Køreskoler',
    '855900': 'Anden undervisning i.a.n.',
    '856000': 'Hjælpeydelser i forbindelse med undervisning',
    '861000': 'Hospitaler',
    '862100': 'Alment praktiserende læger',
    '862200': 'Praktiserende speciallæger',
    '862300': 'Praktiserende tandlæger',
    '869010': 'Sundhedspleje, hjemmesygepleje og jordemødre mv.',
    '869020': 'Fysio- og ergoterapeuter',
    '869030': 'Psykologisk rådgivning',
    '869040': 'Kiropraktorer',
    '869090': 'Sundhedsvæsen i øvrigt i.a.n.',
    '871010': 'Plejehjem',
    '871020': 'Institutionsophold med sygepleje i.a.n.',
    '872010': 'Døgninstitutioner for personer med psykiske handicap',
    '872020': 'Behandlingshjem for stofmisbrugere og alkoholskadede',
    '873010': 'Døgninstitutioner for personer med fysisk handicap',
    '873020': 'Beskyttede boliger o.l.',
    '879010': 'Døgninstitutioner for børn og unge',
    '879020': 'Familiepleje',
    '879090': 'Andre former for institutionsophold',
    '881010': 'Hjemmehjælp',
    '881020': 'Dagcentre mv.',
    '881030': 'Revalideringsinstitutioner',
    '889110': 'Dagplejemødre',
    '889120': 'Vuggestuer',
    '889130': 'Børnehaver',
    '889140': 'Skolefritidsordninger og fritidshjem',
    '889150': 'Aldersintegrerede institutioner',
    '889160': 'Fritids- og ungdomsklubber',
    '889910': 'Foreninger, legater og fonde med sygdomsbekæmpende, sociale og velgørende formål',
    '889920': 'Flygtninge- og asylcentre',
    '889990': 'Andre sociale foranstaltninger uden institutionsophold i.a.n.',
    '900110': 'Teater- og koncertvirksomhed',
    '900120': 'Selvstændigt udøvende scenekunstnere',
    '900200': 'Hjælpeaktiviteter i forbindelse med scenekunst',
    '900300': 'Kunstnerisk skaben',
    '900400': 'Drift af teater- og koncertsale, kulturhuse mv.',
    '910110': 'Biblioteker ',
    '910120': 'Arkiver',
    '910200': 'Museer',
    '910300': 'Historiske monumenter og bygninger og lignende attraktioner',
    '910400': 'Botaniske og zoologiske haver samt naturreservater',
    '920000': 'Lotteri- og anden spillevirksomhed',
    '931100': 'Drift af sportsanlæg',
    '931200': 'Sportsklubber',
    '931300': 'Fitnesscentre',
    '931900': 'Andre sportsaktiviteter',
    '932100': 'Forlystelsesparker o.l.',
    '932910': 'Lystbådehavne',
    '932990': 'Andre forlystelser og fritidsaktiviteter',
    '941100': 'Erhvervs- og arbejdsgiverorganisationer',
    '941200': 'Faglige sammenslutninger',
    '942000': 'Fagforeninger',
    '949100': 'Religiøse institutioner og foreninger',
    '949200': 'Politiske partier',
    '949900': 'Andre organisationer og foreninger i.a.n.',
    '951100': 'Reparation af computere og ydre enheder',
    '951200': 'Reparation af kommunikationsudstyr',
    '952100': 'Reparation af forbrugerelektronik',
    '952200': 'Reparation af husholdningsapparater og redskaber til hus og have',
    '952300': 'Reparation af skotøj og lædervarer',
    '952400': 'Reparation af møbler og boligudstyr',
    '952500': 'Reparation af ure, smykker og guld- og sølvvarer',
    '952900': 'Reparation af andre varer til personligt brug og husholdningsbrug',
    '960110': 'Erhvervs- og institutionsvaskerier',
    '960120': 'Renserier, selvbetjeningsvaskerier mv.',
    '960210': 'Frisørsaloner',
    '960220': 'Skønheds- og hudpleje',
    '960300': 'Bedemænd og begravelsesvæsen',
    '960400': 'Aktiviteter vedrørende fysisk velvære',
    '960900': 'Andre personlige serviceydelser i.a.n.',
    '970000': 'Husholdninger med ansat medhjælp',
    '981000': 'Private husholdningers produktion af varer til eget brug, i.a.n.',
    '982000': 'Private husholdningers produktion af tjenesteydelser til eget brug, i.a.n.',
    '990000': 'Ekstraterritoriale organisationer og organer',
    '999999': 'Uoplyst',
};
//# sourceMappingURL=index.js.map